function updateWrapperClass(swiper) {
    const slides = swiper.slides.length;
  
    const swiperWrapper = swiper.wrapperEl; 
  
    // Add or remove class based on slide count being less than 6
    if (slides < 6) {
      swiperWrapper.classList.add('center-justify');
    } else {
      swiperWrapper.classList.remove('center-justify');
    }
}

/* Product Swiper */
var swiper = new Swiper(".productSwiper", {
    slidesPerView: "auto",
    spaceBetween: 32,
    loop: true,
    pagination: {
        el: ".swiper-pagination-nav",
        type: "fraction",
    },
    navigation: {
        nextEl: ".productSwiperNext",
        prevEl: ".productSwiperPrev",
    },
    on: {
        init: function () {
            updateWrapperClass(this); // Update wrapper class on initialization
        },
        resize: function () {
            updateWrapperClass(this); // Re-check and update wrapper class on resize
        }
    }
});




/* Family Swiper */
var swiper = new Swiper(".familySwiper", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });

/* Full Image Swiper */
 var swiper = new Swiper(".fullImageSwiper", {
      loop:true,
       speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: ".swiper-pagination-nav",
        type: "fraction",
      },
   navigation: {
        nextEl: ".fullSwiperNext",
        prevEl: ".fullSwiperPrev",
      },
    });
  

/* Team Swiper */
var swiper = new Swiper(".teamSwiper", {
    slidesPerView: "auto",
    spaceBetween: 32,
    loop:true,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".teamSwiperNext",
        prevEl: ".teamSwiperPrev",
      },
});

/* Fullscreen Swiper */
var swiper = new Swiper(".fullScreenSwiper", {
  autoHeight: true,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".fullScreenSwiperNext",
        prevEl: ".fullScreenSwiperPrev",
      },
});

/* Gallery Swiper */
var swiper = new Swiper(".gallerySwiper", {
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".gallerySwiperNext",
        prevEl: ".gallerySwiperPrev",
      },
    breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
        1171: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
});

/* Author Swiper */
var swiper = new Swiper(".authorSwiper", {
    slidesPerView: 1,
    spaceBetween: 32,
});

/* Testimonials Swiper */
var swiper = new Swiper(".testimonialSwiper", {
    slidesPerView: 1,
    spaceBetween: 32,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".testimonialSwiperNext",
        prevEl: ".testimonialSwiperPrev",
      },
});

/* 3 Cols Swiper */
var swiper = new Swiper(".SwiperCols", {
      slidesPerView: 1,
      spaceBetween: 32,
      pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".colSwiperNext",
        prevEl: ".colSwiperPrev",
      },
  breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
        1171: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });

/* product images swiper !!MUST BE AT END OF SCRIPT FILE!! WHO KNOWS WHY?? \o/ */
var swiper = new Swiper('.mediaSwiper ', {
  loop: true,
  spaceBetween: 32,
  pagination: {
        el: ".swiper-pagination-nav",
        type: "fraction",
      },
   navigation: {
        nextEl: ".productSwiperNext",
        prevEl: ".productSwiperPrev",
      },
});
